<script setup>
import { ref, watch } from "vue";
import gql from "graphql-tag";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useQuery } from '@vue/apollo-composable'

import IMPERSONATION_QUERY from '@/graphql/Impersonation/ImpersonationQuery.gql'

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const impersonationId = route.params.id 

const isLoading = ref(false);

const { result, loading, onResult } = useQuery(IMPERSONATION_QUERY, {
  id: impersonationId
})

const queryPath = route.query.path;


onResult(({data})=>{
  if(data){
    const token = data.impersonation.token;
    authStore.addAuth(token)
  }
});

watch(authStore, (store)=>{
  setTimeout(()=>{
    if(store.authUser){
      window.location.href = queryPath ?? '/publisher/dashboard'
    }
  }, 500)
})

</script>

<template>
  <div
    class="flex flex-1 flex-col items-center justify-center px-6 py-12 lg:px-8 overflow-hidden relative z-100 h-full items-center"  
  >
    <div class="mx-auto w-full sm:max-w-sm">
      <img
        class="mx-auto h-14 w-auto pr-4"
        src="@/assets/images/ytz-logo.svg"
        alt="YTZ company logo"
      />
    </div>

    <div class="mt-10 mx-auto w-full max-w-xs md:max-w-sm text-center">
      <v-icon name="ri-loader-5-line" class="ov-spin w-8 h-8" />
    </div>
  </div>
</template>

<style scoped>
</style>